module.exports = __webpack_public_path__ + "media/entities/2303-2bc1c389.png";